import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import maneLogo from '../assets/MANE_logo1.png';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="bg-michigan-blue shadow-lg fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2">
            <img src={maneLogo} alt="MANE Logo" className="w-10 h-10" />
            <span className="font-bold text-xl text-white">MANE</span>
          </Link>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8">
            <Link to="/" className={`${isActive('/') ? 'text-michigan-maize' : 'text-white'} hover:text-michigan-maize transition`}>Home</Link>
            <Link to="/about" className={`${isActive('/about') ? 'text-michigan-maize' : 'text-white'} hover:text-michigan-maize transition`}>About Us</Link>
            <Link to="/events" className={`${isActive('/events') ? 'text-michigan-maize' : 'text-white'} hover:text-michigan-maize transition`}>Events</Link>
            <Link to="/resources" className={`${isActive('/resources') ? 'text-michigan-maize' : 'text-white'} hover:text-michigan-maize transition`}>Resources</Link>
            <Link to="/join" className={`${isActive('/join') ? 'text-michigan-maize' : 'text-white'} hover:text-michigan-maize transition`}>Join Us</Link>
            <Link to="/contact" className={`${isActive('/contact') ? 'text-michigan-maize' : 'text-white'} hover:text-michigan-maize transition`}>Contact</Link>
          </div>

          {/* Mobile menu button */}
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden text-white">
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-michigan-blue border-t border-michigan-maize">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <Link to="/" onClick={() => setIsMenuOpen(false)} className="block w-full text-left px-3 py-2 text-white hover:bg-blue-900">Home</Link>
            <Link to="/about" onClick={() => setIsMenuOpen(false)} className="block w-full text-left px-3 py-2 text-white hover:bg-blue-900">About Us</Link>
            <Link to="/events" onClick={() => setIsMenuOpen(false)} className="block w-full text-left px-3 py-2 text-white hover:bg-blue-900">Events</Link>
            <Link to="/resources" onClick={() => setIsMenuOpen(false)} className="block w-full text-left px-3 py-2 text-white hover:bg-blue-900">Resources</Link>
            <Link to="/join" onClick={() => setIsMenuOpen(false)} className="block w-full text-left px-3 py-2 text-white hover:bg-blue-900">Join Us</Link>
            <Link to="/contact" onClick={() => setIsMenuOpen(false)} className="block w-full text-left px-3 py-2 text-white hover:bg-blue-900">Contact</Link>
          </div>
        </div>
      )}
    </nav>
  );
}
